import * as React from 'react';
const SudorazioneDelleAscelleIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M67.84 102s1.82-6.02 16.96-9.52c12.2-2.82 25.86-13.89 30.27-17.4a5.6 5.6 0 0 0 2.05-3.45c.96-5.72.49-17.38.49-17.38M90.57 114.89s-5.61 8.12 3.06 17.91c4.17 4.71 4.97 9.49 5.21 12.95M94.58 102s-7.34 3.31-9.85 10.82"
      className="prefix__cls-2"
    />
    <path
      d="M73.71 74.95s-2.38 17.67 9.1 18.02M98.83 111.74c-7.9 7.87-7.91 17.32-7.91 17.32M130.57 54.25s2.26 17.03 1.39 26.47c-.27 2.94-1.14 5.01-3.95 7.56-1.98 1.79-4.05 3.4-7.56 6.28"
      className="prefix__cls-2"
    />
    <path
      d="M104.29 109.45c0 3.87 3.25 7.01 7.27 7.01s7.27-3.14 7.27-7.01c0-1.2-.31-2.33-.86-3.32l-6.41-11.48-6.4 11.48c-.55.99-.87 2.12-.87 3.32M118.08 128.71c0 2.26 1.9 4.08 4.24 4.08s4.24-1.83 4.24-4.08c0-.7-.18-1.36-.5-1.93l-3.73-6.69-3.73 6.69c-.32.58-.5 1.23-.5 1.93Z"
      className="prefix__cls-1"
    />
  </svg>
);
export default SudorazioneDelleAscelleIcon;
